import React from "react";
import styles from "../styles";
import {apiDeleteReportContent} from "../api/reports";
import {useToast, useConfirm} from "../components/FeedbackProvider";

export default function ReportsPage({reports, selectedGroup, onRefresh}) {
    const {notify} = useToast();
    const confirm = useConfirm();

    async function deleteReportedContent(report) {
        if (!(await confirm("Supprimer le contenu signalé ?", {danger: true}))) return;
        apiDeleteReportContent(report.id).then(() => {
            notify("Contenu et signalement supprimés.", "success");
            onRefresh();
        });
    }

    return (
        <>
            <h2 style={{fontFamily: "'Fraunces', serif"}}>🚩 Signalements</h2>
            {reports.length === 0 ? (
                <p>Aucun signalement.</p>
            ) : (
                reports.map(report => (
                    <div key={report.id} style={styles.card}>
                        <p><strong>Type :</strong> {report.type}</p>
                        <p><strong>ID cible :</strong> {report.target_id}</p>
                        <p><strong>Raison :</strong> {report.reason}</p>
                        <p><strong>Date :</strong> {report.created_at}</p>
                        <button onClick={() => deleteReportedContent(report)} style={styles.dangerButton}>
                            Supprimer le contenu
                        </button>
                    </div>
                ))
            )}
        </>
    );
}
